import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=5230074a&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&id=5230074a&prod&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=5230074a&prod&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&id=5230074a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230074a",
  null
  
)

export default component.exports